<ngx-spinner name="spinner" bdColor="rgba(0, 0, 0, 0.2)" size="medium" color="#00D2B4" type="timer"
    [fullScreen]="false"></ngx-spinner>

<div class="login-container">
    <mat-card appearance="outlined" class="box">
        <div class="version">v{{ version }}</div>

        <form class="form-container" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
            <fa-icon class="authenticate-icon" [icon]="fakey"></fa-icon>
            
            <a class="link" (click)="forgottenPassword()">VOUS N'AVEZ PAS VOTRE MOT DE PASSE ? CLIQUEZ ICI.</a>

            <mat-form-field>
                <mat-label>Account</mat-label>
                <input matInput formControlName="account" autocomplete="false" required />
                <mat-error>Veuillez saisir un compte valide</mat-error>
            </mat-form-field>

            <mat-form-field>
                <mat-label>Mot de passe</mat-label>
                <input [type]="hide ? 'password' : 'text'" matInput formControlName="password" autocomplete="false"
                    required />
                    <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide" type="button">
                        <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
                    </button>
                <mat-error>Veuillez saisir un mot de passe valide</mat-error>
            </mat-form-field>

            <div class="submit-container">
                <button mat-raised-button class="accent-button" [disabled]="!loginForm.valid" type="submit">Connexion</button>
            </div>

            @if (expired) {
            <mat-error class="errorMessage">Votre session a expirée</mat-error>
            }
            @if (authenticationInvalid) {
            <mat-error class="errorAuth">Une erreur est survenue, veuillez vérifier vos identifiants</mat-error>
            }
        </form>
    </mat-card>
</div>